(async function waitForTryNow() {
    while (typeof window.trynow === 'undefined' || window.trynow === null) {
      await new Promise(resolve => setTimeout(resolve, 50)); 
    }
  
    const ctaButtonRuleset = window.trynow.createVisibilityRuleset({
      rank: 10,
      rules: [
        {
          rank: 10,
          ruleTest: () => window.Shopify.country != 'US',
          ruleOutcome: () => {
            const ctaButton = document.querySelector(
              '.add_to_bag_btn button'
            );
            const tryNowButton =
              document.querySelector('trynow-cta-button');
            const tryNowToggle = document.querySelector(
              '.tn-gate-toggle-input'
            );
            const tryNowButtonMenu = document.querySelector('#HeaderMenu-try-it-free');
            
            if (ctaButton) {
              ctaButton.style.display = 'unset';
            }
            if (tryNowButton) {
              tryNowButton.parentElement.style.display = 'none';
            }
            if (tryNowToggle && tryNowToggle.checked) {
              tryNowToggle.click();
              document.cookie = '_tn_gate_toggle=false; path=/';
            }
            if(tryNowButtonMenu) {
              tryNowButtonMenu.style.display = 'none';
            }
          },
        },
      ],
    });
    window.trynow.getComponent('ctaButton', true).then((ctaButton) => {
      const ruleset = ctaButton.getRuleset(10)
      if(ruleset === undefined){
        ctaButton.addRuleset(ctaButtonRuleset);
      }
    });


    if(window.Shopify.country != 'US'){
      const style = document.createElement("style");
      style.innerHTML = `
        .trynow-subhero-banner,
        [link-title="Try Before You Buy"],
        [link-title="Try At Home"],
        .tryNowCtaBanner.tryNowCtaBannerDesktop,
        .tryNowCtaBanner.tryNowCtaBannerMobile,
        .trynowBadgeLabel,
        .trynowBadgeLabel.trynowBadgeLabelMobile,
        .tnDescription,
        .trynowBadgeLabelToggle,
        .tryNowPriceToggle,
        .try-banner,
        .tryNow_quick_link,
        .trynow-grid-item,
        #HeaderMenu-try-it-free,
        div:has(>img[alt="Try Free"]),
        #_loomi_addon_1754388218096,
        .tryNowSwitch {
          display: none !important;
        }

        ProductMeta__PriceList.Heading.Price_List_Mobile.observer .ProductMeta__Price.ProductDynamic_Money {
          display: block !important;
        }

        .Heading.Price_List_Mobile.observer .ProductMeta__Price.Price.Price--compareAt {
          display: unset !important;
        }

        .Heading.Price_List_Mobile.observer .ProductMeta__Price.Price.Price--highlight {
          display: unset !important;
        }

        .ProductMeta__PriceList.Heading.Price_List_Desktop.observer .ProductMeta__Price.ProductDynamic_Money {
          display: block !important;
        }

        .tbyb-atc-meta-blocked {
          display: unset !important;
        }
      `;
      document.head.appendChild(style);
    }


  })();